/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function AddTransparent(props: CustomSvgIcon) {
    const {
        className,
        id,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id}
            onClick={onClick}
        >
            <svg
                height='24'
                width='24'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g>
                    <title>Layer 1</title>
                    <g
                        id='svg_9'
                        stroke='null'
                    >
                        <g
                            id='svg_12'
                            stroke='null'
                        >
                            <rect
                                fill={iconColor || '#000'}
                                height='23.282318'
                                id='svg_10'
                                width='3.847834'
                                x='9.942877'
                                y='0.290019'
                            />
                            <rect
                                fill={iconColor || '#000'}
                                height='3.833902'
                                id='svg_11'
                                width='23.116217'
                                x='0.328477'
                                y='10.091777'
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}